export const REVIEW_STATUS_DEFAULT = 'UNREVIEWED';
export const REVIEW_STATUS_FAILED = 'FAIL_REVIEW';
export const REVIEW_STATUS_PASSED = 'PASS_REVIEW';
export const REVIEW_STATUS_NO_NEED_REVIEW = 'NO_NEED_REVIEW';
export const REVIEW_STATUS: { [key: string]: string } = {
  UNREVIEWED: 'general.reviewStatus.UNREVIEWED', //Not Reviewed
  FAIL_REVIEW: 'general.reviewStatus.FAIL_REVIEW', //Failed
  PASS_REVIEW: 'general.reviewStatus.PASS_REVIEW', //Passed
  NO_NEED_REVIEW: 'general.reviewStatus.NO_NEED_REVIEW', //Not Required
};

/** Goods Shipping Method */
export const SHIPPING_METHOD: { [key: string]: string } = {
  SHIPPING: 'SHIPPING',
  PICKUP: 'PICKUP',
};

/** Boolean to Yes-No Status */
export const BOOLEAN_TO_STATUS: { [key: string]: string } = {
  true: `general.booleanToStatus.true`, //Yes
  false: `general.booleanToStatus.false`, //No
};

/**Employee Status */
export const EMPLOYEE_DEFAULT_STATUS = 'OFF_DUTY';

/*** Ad position location 广告位位置 */
export const Ad_POSITION_LOCATION_CATEGORY = 'CATEGORY_LIST';

export const MAIL_TEMP_CODE = {
  ORDER_STATEMENT: 'ORDER_STATEMENT',
  ORDER_INVOICE: 'ORDER_INVOICE',
  ORDER_CLAIM: 'ORDER_CLAIM',
}

/**
 * POS terminal default "walk-in" customer.
 * Every POS order is attached to a real user; walk-in sales use this preset
 * account (which carries a default saved address). Change here when the final
 * walk-in account id is decided.
 */
export const POS_WALK_IN_USER_ID = 0;
